function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("g", {
  id: "_225717664"
}, /*#__PURE__*/React.createElement("rect", {
  id: "_225511648",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x: 470.557,
  y: 938.713,
  width: 218.172,
  height: 218.172,
  rx: 27.7677,
  ry: 27.7677
}), /*#__PURE__*/React.createElement("rect", {
  id: "_225511816",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x: 720.463,
  y: 938.713,
  width: 218.172,
  height: 218.172,
  rx: 27.7677,
  ry: 27.7677
}), /*#__PURE__*/React.createElement("rect", {
  id: "_225511792",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x: 970.369,
  y: 938.713,
  width: 218.172,
  height: 218.172,
  rx: 27.7677,
  ry: 27.7677
}), /*#__PURE__*/React.createElement("rect", {
  id: "_225511552",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x: 470.557,
  y: 688.807,
  width: 218.172,
  height: 218.172,
  rx: 27.7677,
  ry: 27.7677
}), /*#__PURE__*/React.createElement("rect", {
  id: "_225721288",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x: 720.463,
  y: 688.807,
  width: 218.172,
  height: 218.172,
  rx: 27.7677,
  ry: 27.7677
}), /*#__PURE__*/React.createElement("rect", {
  id: "_225707920",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x: 1220.27,
  y: 938.713,
  width: 218.172,
  height: 218.172,
  rx: 27.7677,
  ry: 27.7677
}), /*#__PURE__*/React.createElement("rect", {
  id: "_225701488",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x: 970.369,
  y: 688.807,
  width: 218.172,
  height: 218.172,
  rx: 27.7677,
  ry: 27.7677
}), /*#__PURE__*/React.createElement("rect", {
  id: "_225726160",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x: 470.557,
  y: 438.902,
  width: 218.172,
  height: 218.172,
  rx: 27.7677,
  ry: 27.7677
}), /*#__PURE__*/React.createElement("rect", {
  id: "_225719392",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x: 720.463,
  y: 438.902,
  width: 218.172,
  height: 218.172,
  rx: 27.7677,
  ry: 27.7677
}), /*#__PURE__*/React.createElement("path", {
  id: "_225717256",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1749.91 1188.62l-1451.82 0 -42.091 0 11.7201 40.5355 79.3335 274.37c8.47914,29.3256 24.15,56.9327 47.8205,76.656 21.3851,17.8205 48.5091,28.9181 81.7194,28.9181l1094.81 0c33.2055,0 60.3331,-11.1 81.717,-28.9205 23.6717,-19.7268 39.3461,-47.3363 47.8229,-76.6536l79.3335 -274.37 11.7201 -40.5355 -42.091 0zm-174.926 147.442c0,-19.6618 15.939,-35.5996 35.6008,-35.5996 19.6618,0 35.6008,15.9378 35.6008,35.5996 0,19.663 -15.939,35.6008 -35.6008,35.6008 -19.6618,0 -35.6008,-15.9378 -35.6008,-35.6008zm-117.317 0c0,-19.6618 15.939,-35.5996 35.6008,-35.5996 19.6618,0 35.6008,15.9378 35.6008,35.5996 0,19.663 -15.939,35.6008 -35.6008,35.6008 -19.6618,0 -35.6008,-15.9378 -35.6008,-35.6008zm-117.317 0c0,-19.6618 15.939,-35.5996 35.5996,-35.5996 19.663,0 35.602,15.9378 35.602,35.5996 0,19.663 -15.939,35.6008 -35.602,35.6008 -19.6606,0 -35.5996,-15.9378 -35.5996,-35.6008zm-117.317 0c0,-19.6618 15.939,-35.5996 35.5996,-35.5996 19.663,0 35.602,15.9378 35.602,35.5996 0,19.663 -15.939,35.6008 -35.602,35.6008 -19.6606,0 -35.5996,-15.9378 -35.5996,-35.6008zm-117.317 0c0,-19.6618 15.9378,-35.5996 35.5996,-35.5996 19.663,0 35.602,15.9378 35.602,35.5996 0,19.663 -15.939,35.6008 -35.602,35.6008 -19.6618,0 -35.5996,-15.9378 -35.5996,-35.6008zm-117.318 0c0,-19.6618 15.9378,-35.5996 35.6008,-35.5996 19.663,0 35.6008,15.9378 35.6008,35.5996 0,19.663 -15.9378,35.6008 -35.6008,35.6008 -19.663,0 -35.6008,-15.9378 -35.6008,-35.6008zm-117.318 0c0,-19.6618 15.939,-35.5996 35.602,-35.5996 19.6618,0 35.5996,15.9378 35.5996,35.5996 0,19.663 -15.9378,35.6008 -35.5996,35.6008 -19.663,0 -35.602,-15.9378 -35.602,-35.6008zm-81.7146 -35.5996c19.6606,0 35.5996,15.9378 35.5996,35.5996 0,19.663 -15.939,35.6008 -35.5996,35.6008 -19.663,0 -35.602,-15.9378 -35.602,-35.6008 0,-19.6618 15.939,-35.5996 35.602,-35.5996zm-117.317 0c19.6606,0 35.5996,15.9378 35.5996,35.5996 0,19.663 -15.939,35.6008 -35.5996,35.6008 -19.663,0 -35.602,-15.9378 -35.602,-35.6008 0,-19.6618 15.939,-35.5996 35.602,-35.5996zm-117.318 0c19.6618,0 35.6008,15.9378 35.6008,35.5996 0,19.663 -15.939,35.6008 -35.6008,35.6008 -19.6618,0 -35.6008,-15.9378 -35.6008,-35.6008 0,-19.6618 15.939,-35.5996 35.6008,-35.5996zm-117.317 0c19.6618,0 35.6008,15.9378 35.6008,35.5996 0,19.663 -15.939,35.6008 -35.6008,35.6008 -19.6618,0 -35.6008,-15.9378 -35.6008,-35.6008 0,-19.6618 15.939,-35.5996 35.6008,-35.5996z"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  width: 2048,
  height: 2048
});

var SvgCargoShip1 = function SvgCargoShip1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "2048px",
    height: "2048px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2048 2048",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCargoShip1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CargoShip1.5ca6fa44.svg";
export { ForwardRef as ReactComponent };